import {
  assessmentFilterTypes,
  deserify,
  DocumentViewer,
  getMediaBasePath,
  IStyles,
  pxToRem,
  pxTovW,
  SearchBar,
  SelectMenu,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { FileEnum } from '@protos/content_management/content.db_pb';

import { Pagination, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ReportTable } from './ReportTable';

import { AssessmentEnum } from '@protos/learning_management/lms.db_pb';
// import { SearchBar } from './components/SearchBar';
import { useAppSelector } from '../../../reduxStore/reduxHooks';
import {
  setReportsData,
  setSelectedSubject,
  setSearchByAssessType,
  setPageNumber,
} from './reducer/report.slice';
import { setToastInfo } from '../../Home/reducer/homeDashboard.slice';
import {
  StudentAssessmentReportData,
  StudentReportCenterData,
} from '@protos/learning_management/lms.assessment.student.apis_pb';

const styles: IStyles = {
  root: {
    // width: '100vw',
    cursor: 'pointer',
    // paddingLeft: { xs: pxToRem(20), lg: pxTovW(241) },
    paddingX: { xs: pxToRem(20), md: pxTovW(20), lg: pxTovW(239) },
    paddingTop: { xs: pxToRem(20), lg: pxTovW(40) },
    paddingBottom: { xs: pxToRem(50), lg: pxTovW(40) },
    // paddingRight: { xs: pxToRem(20), lg: pxTovW(241) },
    boxSizing: 'border-box',
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
  pagination: {
    width: 'max-content',
    margin: 'auto',
    mt: { xs: pxToRem(20), md: pxTovW(30) },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
  },
  inputFeild: {
    backgroundColor: 'red',
    display: 'flex',
    height: { xs: pxToRem(50), md: pxTovW(56) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    border: '1px solid #CCE6FE',
    width: { xs: pxToRem(311), lg: pxTovW(457) },
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  inputBox: {
    display: 'flex',
    justifyContent: { xs: 'space-between', md: 'center' },
    gap: { xs: pxToRem(10), md: pxTovW(10) },
  },
  inputFeildBox: {
    paddingTop: { xs: pxToRem(20), md: pxTovW(5) },
    paddingLeft: { xs: pxToRem(10), md: pxTovW(70) },
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(6), md: pxTovW(12) },
  },
};

export const Reports = () => {
  const [loading, setLoading] = useState<'loading' | 'completed' | 'error'>(
    'completed'
  );
  const [selectedSubjectId, setSelectedSubjectId] = useState<string>('');

  const { userInfo } = deserify(useAppSelector((state) => state.auth));

  // const [searchByAssessType, setSearchByAssessType] = useState<
  //   IAssessmentTypes | undefined
  // >();

  const [searchText, setSearchText] = useState<string>('');
  // const [rowData, setRowData] = useState<ReportData[] | null>(null);
  const [pdfUrl, setPdfUrl] = useState<string | undefined>(undefined);
  const [selectedAssessmentId, setSelectedAssessmentId] = useState<
    string | undefined
  >(undefined);
  const [reportFileNamePrefix, setReportFileNamePrefix] = useState<
    string | undefined
  >(undefined);
  const studentId = deserify(
    useAppSelector((state) => state.auth.userInfo?.studentProfileId)
  );
  const { setectedSubject, reportsData, searchByAssessType, pageNumber } =
    useAppSelector((state) => state.reports);
  const dispatch = useDispatch();
  // const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // const [totalCount, setTotalCount] = useState<number | undefined>();
  const {
    LmsAssessmentStudentReportsAPIServiceV1ClientWithStatusCodeHandler,
    SchoolAssessmentAPIServiceV3ClientWithStatusCodeHandler,
  } = useCommonServiceClientContext();

  const headers = [
    { name: 'SUBMISSION DATE' },
    { name: 'ASSESSMENT NAME' },
    { name: 'ASSESSMENT TYPE' },
    { name: 'SUBJECT' },
    { name: 'ACTION' },
  ];

  useEffect(() => {
    fetchReport(
      setectedSubject?.subjectId ?? 0,
      searchByAssessType?.id ?? AssessmentEnum.ASSESSMENT_UNDEFINED,
      pageNumber,
      searchText
    );
  }, [searchByAssessType?.id, setectedSubject?.subjectId]);

  const fetchReport = async (
    subjectId: number,
    assessmentType: AssessmentEnum,
    pageNumber: number,
    search?: string
  ) => {
    setLoading('loading');
    try {
      const response =
        await LmsAssessmentStudentReportsAPIServiceV1ClientWithStatusCodeHandler.studentAssessmentReportResponse(
          {
            studentId: studentId,
            pageNumber: pageNumber,
            subjectId: subjectId ? subjectId : undefined,
            assessmentType: assessmentType ? assessmentType : undefined,
            searchKey: search ? search?.trim() : undefined,
          }
        );
      if (response.data) {
        dispatch(setReportsData(response.data));
        setLoading('completed');
        calculatePaginationInfo(response.data);
      } else {
        setLoading('error');
        dispatch(
          setToastInfo({
            label: 'Something went wrong',
            variant: 'error',
            open: true,
          })
        );
      }
    } catch (err) {
      console.log(err, 'error');
      setLoading('error');
      dispatch(
        setToastInfo({
          label: 'Something went wrong',
          variant: 'error',
          open: true,
        })
      );
    }
  };

  const genrateReports = async (row: StudentReportCenterData) => {
    if (!studentId) return;
    setLoading('loading');
    try {
      const response =
        await SchoolAssessmentAPIServiceV3ClientWithStatusCodeHandler.fetchStudentAssessmentReport(
          {
            assessmentId: row.assessmentId
              ? Number(row.assessmentId)
              : undefined,
            studentId: studentId,
          }
        );
      if (response) {
        if (
          !response.data?.gcpReportUrl ||
          response.data?.gcpReportUrl === 'null'
        ) {
          dispatch(
            setToastInfo({
              label: response?.message
                ? `${response?.message.replace(/\[.*?\]/g, '')}`
                : 'Assessment report Generation in Progress',
              variant: 'success',
              open: true,
            })
          );
          setLoading('completed');
          return;
        }
        fetchReport(
          setectedSubject?.subjectId ?? 0,
          searchByAssessType?.id ?? AssessmentEnum.ASSESSMENT_UNDEFINED,
          pageNumber,
          searchText
        );
      }
      const reportRow = reportsData?.studentReports?.find(
        (report) => report.assessmentId === row.assessmentId
      );
      const subjectPrefix = (reportRow?.subject ?? row.subject ?? '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
        .join('_');
      const classSection = [
        userInfo?.classSectionDetails?.className,
        userInfo?.classSectionDetails?.sectionName,
      ]
        .filter(Boolean)
        .join('_');
      const reportPrefix = [subjectPrefix, classSection]
        .filter(Boolean)
        .join('_');
      setPdfUrl(getMediaBasePath(response.data?.gcpReportUrl));
      setSelectedAssessmentId(row.assessmentId);
      setReportFileNamePrefix(reportPrefix || undefined);
      setLoading('completed');
    } catch (error) {
      console.log(error);
      setLoading('completed');
      dispatch(
        setToastInfo({
          label: 'Error in genrating report',
          variant: 'error',
          open: true,
        })
      );
    }
  };

  const handleSearch = (search: string) => {
    dispatch(
      setPageNumber(1) // Reset to first page on search
    );
    fetchReport(
      setectedSubject?.subjectId ?? 0,
      searchByAssessType?.id ?? AssessmentEnum.ASSESSMENT_UNDEFINED,
      1,
      search
    );
  };

  const calculatePaginationInfo = (
    paginationData: StudentAssessmentReportData
  ) => {
    const countInPagination = Number(
      paginationData?.studentReportsInfo?.countInPagination || 1
    );

    const reportsCount = Number(
      paginationData?.studentReportsInfo?.reportCount || 0
    );

    const totalPages = Math.ceil(reportsCount / countInPagination);

    setTotalPages(totalPages);
  };

  return (
    <Box
      sx={{
        padding: {
          xs: `${pxToRem(0)} ${pxToRem(20)} ${pxToRem(20)} ${pxToRem(20)}`,
          md: ` ${pxTovW(27)} ${pxTovW(50)}`,
          lg: ` ${pxTovW(30)} ${pxTovW(230)}`,
        },
      }}
    >
      <Typography variant="h2">All Reports</Typography>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: {
            xs: 'space-between',
            md: 'space-between',
            lg: 'center',
          },
          gap: { xs: pxToRem(10), md: pxTovW(15), lg: pxTovW(10) },
          // marginLeft: { lg: pxTovW(60) },
          // marginLeft: { xs: pxToRem(10), md: pxTovW(120) },
        }}
      >
        <Box
          sx={{
            width: { xs: 'max-content', md: pxTovW(550), lg: pxTovW(474) },
            marginTop: { xs: pxToRem(15), md: pxTovW(38), lg: pxTovW(34) },
            // marginRight: { xs: pxToRem(10), md: pxToRem(100) },
          }}
        >
          <SearchBar
            searchText={searchText}
            handleSearchTextChange={(value) => {
              setSearchText(value);
              if (value === '' || value === null) {
                fetchReport(
                  setectedSubject?.subjectId ?? 0,
                  searchByAssessType?.id ?? AssessmentEnum.ASSESSMENT_UNDEFINED,
                  1
                ); // Trigger fetch when cleared
              }
            }}
            handleSearch={() => {
              handleSearch(searchText);
            }}
            handleClose={() => {
              setSearchText('');
              handleSearch('');
              // getTeacherList('');
            }}
          />
        </Box>

        <Box sx={styles.selectContainer}>
          <Typography variant="h4">Choose Subject</Typography>
          <SelectMenu
            placeholder="Select"
            clearIcon={true}
            value={
              setectedSubject?.subjectName ? setectedSubject?.subjectName : ''
            } // avoid passing NaN
            onChange={(val: string) => {
              dispatch(setPageNumber(1));
              if (!val) {
                dispatch(setSelectedSubject(undefined));
              } else {
                // setSelectedSubjectId(val); // val is subjectId as string
                const subjectObj = userInfo?.learnSubjects.find(
                  (s) => s.subjectName === val
                );

                if (subjectObj) {
                  dispatch(setSelectedSubject(subjectObj));
                }
              }
            }}
            optionList={(userInfo?.learnSubjects || []).map((subject) => ({
              name: subject.subjectName, // what shows in dropdown
              id: subject.subjectId, // what is stored as value
            }))}
            rootStyles={{
              width: { xs: pxToRem(152), md: pxTovW(540), lg: pxTovW(280) },
              height: { xs: pxToRem(30), md: pxTovW(75), lg: pxTovW(56) },
            }}
          />
        </Box>

        <Box sx={styles.selectContainer}>
          <Typography variant="h4">Choose Assessment Type</Typography>
          <SelectMenu
            placeholder="Select"
            value={searchByAssessType ? searchByAssessType.name : ''}
            onChange={(value: string) => {
              const selectedAssessmentType = assessmentFilterTypes.find(
                (option) => option.name === value
              );
              dispatch(setPageNumber(1));
              // setSearchByAssessType(selectedAssessmentType);
              dispatch(setSearchByAssessType(selectedAssessmentType));
            }}
            optionList={assessmentFilterTypes.filter(
              (option) => option.name !== 'Question Paper'
            )}
            rootStyles={{
              width: { xs: pxToRem(152), md: pxTovW(540), lg: pxTovW(230) },
              height: { xs: pxToRem(30), md: pxTovW(75), lg: pxTovW(56) },
            }}
            clearIcon={true}
          />
        </Box>
      </Box>

      <ReportTable
        headers={headers}
        searchText={searchText}
        generateReports={genrateReports}
        loading={loading}
        onDownloadClick={(url) => setPdfUrl(url)}
        icon="report-icon"
      />

      {(reportsData?.studentReports ?? []).length > 0 && (
        <Pagination
          page={pageNumber}
          count={totalPages}
          color="secondary"
          onChange={async (event: React.ChangeEvent<unknown>, page: number) => {
            fetchReport(
              setectedSubject?.subjectId ?? 0,
              searchByAssessType?.id ?? AssessmentEnum.ASSESSMENT_UNDEFINED,
              page,
              searchText
            );
            dispatch(setPageNumber(page));
          }}
          sx={styles.pagination}
        />
      )}

      {pdfUrl && (
        <DocumentViewer
          downloadUrl={pdfUrl}
          previewUrl={pdfUrl}
          gcpUrl={pdfUrl}
          type={FileEnum.FILE_TYPE_PDF}
          fileName={
            reportFileNamePrefix
              ? selectedAssessmentId
                ? `${reportFileNamePrefix}_Geneo_Assessment_Report_${selectedAssessmentId}_Student_${studentId}`
                : `${reportFileNamePrefix}_Geneo_Assessment_Report_Student_${studentId}`
              : selectedAssessmentId
              ? `Geneo_Assessment_Report_${selectedAssessmentId}_Student_${studentId}`
              : `Geneo_Assessment_Report_Student_${studentId}`
          }
          open={!!pdfUrl}
          closeFile={() => {
            setPdfUrl(undefined);
            setSelectedAssessmentId(undefined);
            setReportFileNamePrefix(undefined);
          }}
        />
      )}
    </Box>
  );
};
